import React, { useCallback } from 'react';
import { RelatedEventCard } from '@/components/RelatedEvents/RelatedEventCard';
import { OrganizerEvent } from '../types';
import { AffiliateCodes, LISTING_HEAP_IDS } from '@/components/_shared/constants';
import { track } from '@eventbrite/legacy-infra.datalayer-library';
import { toRelatedEvent } from '../utils';

export interface MoreOrganizerEventCardProps {
  organizerEvent: OrganizerEvent;
  affiliateCode?: AffiliateCodes;
}

export const MoreOrganizerEventCard: React.FC<MoreOrganizerEventCardProps> = ({ organizerEvent, affiliateCode }) => {
  const relatedEvent = toRelatedEvent(organizerEvent);

  const handleCardClick = useCallback(() => {
    track({
      eventName: LISTING_HEAP_IDS.ORGANIZER_MORE_EVENTS_CLICK,
      eventData: {
        event_id: relatedEvent.id,
        event_name: relatedEvent.name,
      },
    });
  }, [relatedEvent.id, relatedEvent.name]);

  return (
    <div onClick={handleCardClick}>
      <RelatedEventCard relatedEvent={relatedEvent} affiliateCode={affiliateCode} />
    </div>
  );
};
